




























import {Component, Prop, Vue} from 'vue-property-decorator';
import Dialogs from '@/components/dialogs.vue';

@Component({
  components: {
    Dialogs
  }
})
export default class AppBase extends Vue {
  @Prop(String) public title?: boolean;
  @Prop(Boolean) public loading?: boolean;
  @Prop(Boolean) public showHomeButton?: boolean;
  @Prop(Boolean) public hideToolbar?: boolean;

  private activeTab = '/';

  public created() {
    this.activeTab = (this.$router as any).history.current.path;
  }

  private onHomeClick() {
    this.$router.push('/');
  }
}
